import {
  createGlobalStyle,
  css
} from "styled-components";

export const ReactGridLayoutStyles = createGlobalStyle`
  ${({ theme }) => css`

    .react-grid-item.react-grid-placeholder {
      background: ${theme.colors.darkGrey};
      opacity: 0.2;
      transition-duration: 100ms;
      z-index: 2;
      user-select: none;

      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      -o-user-select: none;
      user-select: none;
    }
  `}
`;
